import styled, { css } from 'styled-components';
import BaseProgressBar from 'src/components/ProgressBar';
import theme, { rtlFlip } from 'src/utils/theme';
import { Icon } from 'src/components';

export const Wrapper = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m}
    display: flex;
    cursor: pointer;
    flex-direction: column;
    flex: 0 1 100%;

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.base};
    }
  `,
);

export const CurrentStage = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary30};
    display: flex;
    flex-wrap: nowrap;
    gap: ${theme.sz.s1};
    margin-bottom: ${theme.sz.s3};
    white-space: nowrap;
    align-items: center;
  `,
);

export const ArrowIcon = styled(Icon)(
  ({ theme }) => css`
    font-size: ${theme.sz.s6};
    svg {
      transform: scaleX(${rtlFlip(theme)});
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    gap: ${theme.sz.s4};
    margin-bottom: ${theme.sz.s3};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.m};
    }
  `,
);
export const ProgressContainer = styled.div(
  ({ theme }) => css`
    align-items: center;
    color: ${theme.co.secondary50};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    white-space: nowrap;

    @media (min-width: ${theme.sz.md}) {
      flex-wrap: nowrap;
      gap: ${theme.sz.s4};
    }
  `,
);

export const NextLevel = styled.div(
  ({ theme }) => css`
    flex-grow: 1;
    order: 2;

    @media (min-width: ${theme.sz.md}) {
      order: initial;
    }
  `,
);

export const CurrentPoints = styled.div(
  () => css`
    flex-grow: 1;
    order: 3;
    text-align: right;
    white-space: nowrap;

    @media (min-width: ${theme.sz.md}) {
      order: initial;
    }
  `,
);

export const ProgressBar = styled(BaseProgressBar)(
  () => css`
    flex-grow: 1;
    height: calc(${theme.sz.s2} + ${theme.sz.s05});
    margin-bottom: ${theme.sz.s2};
    order: 1;

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: initial;
      order: initial;
    }

    > * {
      height: inherit;
    }
  `,
);
